import React, { FC, useCallback, useEffect, useState } from "react";
import { FormLayout, Select, Stack, Text, TextField } from "@shopify/polaris";
import { getQualifierOptions } from "./helpers/getQualifierOptions.js";
import {
  qualifierOptionsWithSelectLocations,
  qualifierOptionsWithSelectTags,
  qualifierOptionsWithSelectValue,
  qualifierOptionsWithValue
} from "../../../../../../../../../../constants/qualifierOptions.js";
import { attributeOptions } from "../../../../../../../../../../constants/attributeOptions.js";
import { FieldRenderProps } from "react-final-form";
import SelectedTagsField from "../../../../../../../../common/SelectedTagsField/SelectedTagsField.js";
import SelectedLocationsField from "../../../../../../../../common/SelectedLocationsField/SelectedLocationsField.js";
import { getSelectValueOptions } from "./helpers/getSelectValueOptions.js";
import { variantAttributes } from "../../../../../../../../../../constants/attributeTypes.js";
import AttributeSelectField from "../../AttributeSection/components/AttributeSelectField.js";

interface SelectedProductsFieldProps extends FieldRenderProps<any> { }

const AttributeConditions: FC<SelectedProductsFieldProps> = ({ input, isMultiple }) => {
  const [type, setType] = useState("attribute");

  useEffect(() => {
    const qualifierOptions = getQualifierOptions(input.value.attribute);
    if (!qualifierOptions.some(item => item.value === input.value.qualifier)) {
      input.onChange({ ...input.value, qualifier: qualifierOptions[0].value });
    }
  }, [input.value, input.onChange]);

  const handleChangeAttribute = useCallback((val) => {
    input.onChange({ ...input.value, attribute: val });
  }, [input]);

  const handleChangeQualifier = useCallback((val) => {
    input.onChange({ ...input.value, qualifier: val });
  }, [input]);

  const handleChangeValue = useCallback((val) => {
    input.onChange({ ...input.value, value: val });
  }, [input]);

  const tagsInput = {
    name: "tags",
    value: input?.value?.value || [],
    onChange: handleChangeValue,
  };

  return (
    <FormLayout>
      <FormLayout.Group condensed>
        <AttributeSelectField
          label={isMultiple ? "Your selection" : "Attribute"}
          options={attributeOptions}
          onChange={handleChangeAttribute}
          value={input.value.attribute}
        />
        <Select
          label="Qualifier"
          options={getQualifierOptions(input.value.attribute)}
          onChange={handleChangeQualifier}
          value={input.value.qualifier}
        />
        {qualifierOptionsWithSelectValue.includes(input.value.qualifier) &&
          <Select
            label="Value"
            options={getSelectValueOptions(input.value.attribute)}
            onChange={handleChangeValue}
            value={input.value.value}
          />
        }
        {qualifierOptionsWithValue.includes(input.value.qualifier) &&
          <TextField
            label="Value"
            onChange={handleChangeValue}
            value={input.value.value}
            autoComplete="off"
          />
        }
        {qualifierOptionsWithSelectTags.includes(input.value.qualifier) &&
          <SelectedTagsField input={tagsInput} labelHidden={false} disabled={false} meta={{ error: "" }} />
        }
        {qualifierOptionsWithSelectLocations.includes(input.value.qualifier) &&
          <SelectedLocationsField input={tagsInput} labelHidden={false} disabled={false} meta={{ error: "" }} />
        }
      </FormLayout.Group>
    </FormLayout>
  );
};

export default AttributeConditions;